'use client'

import React from 'react'
import GameLink from '../custom-links/game-link'
import s from './style.module.scss'
import {BackToTopT} from './back-to-top-server'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

type Props = {
  gameName: string
  gameCode: string
  propertyCode: string
  translations: BackToTopT
}

const BackToTopClient = ({gameName, gameCode, propertyCode, translations}: Props) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <>
      <GameLink
        gameCode={gameCode}
        propertyCode={propertyCode}
        gameName={gameName}
        className={s.filled_btn}
        onClick={triggerAnalytics('play-random-clicked').sendAll}
      >
        <span className={s.wrap_container}>🎲 {translations.RandomGame}</span>
      </GameLink>
      <button
        className={s.unfilled_btn}
        onClick={() => {
          scrollToTop()
          triggerAnalytics('back-to-top-clicked').sendAll()
        }}
      >
        <span className={s.wrap_container}>⬆️ {translations.BackToTop}</span>
      </button>
    </>
  )
}

export default BackToTopClient
